<template>
  <div>
    <HeroSection />
    <AboutSection />
    <AuthorVideoSection :video-id="introVideoId" />
    <LessonsGrid :lessons="lessons" :loading="loading" />
    <FaqSection />
    <CtaBanner />
  </div>
</template>

<script setup lang="ts">
import { COURSE_CONFIG } from '~/config/course'
const { t } = useI18n()
const config = useRuntimeConfig()
const { lessons, loading, fetchLessons } = useLesson()
const introVideoId = config.public.introVideoId || COURSE_CONFIG.introVideoId
await fetchLessons()

useHead({
  title: t('meta.homeTitle'),
  meta: [
    { name: 'description', content: t('meta.homeDesc') },
    { name: 'keywords', content: 'Основи Віри, Біблія, AWR360, курс, уроки' },
    { property: 'og:title', content: t('meta.homeTitle') },
    { property: 'og:description', content: t('meta.homeDesc') },
    { property: 'og:url', content: 'https://osnovy.bibleawr.com' },
    { property: 'og:locale', content: 'uk_UA' },
    { name: 'twitter:title', content: t('meta.homeTitle') },
    { name: 'twitter:description', content: t('meta.homeDesc') },
  ],
})
</script>
